<div class="dropdown" [ngClass]="{ expanded: showMenu }" tabindex="-1" (blur)="menuToggle(false)" data-crlat="dropdown">
    <div
        (click)="menuToggle()"
        class="dropdown-header"
        [ngClass]="{ 'dropdown-header-not-coupon': !isFromCoupon, 'dropdown-header-coupon': isFromCoupon }">
        @if (isFromCoupon) {
            <span class="toggle" [textContent]="toggleTitle" data-crlat="item-selected"></span>
        }
        @if (!isFromCoupon && !isMybets) {
            <span class="market-swt-label" [textContent]="toggleTitle"></span>
        }
        <div data-crlat="open-menu-button" [ngClass]="{ 'change-btn': !isFromCoupon, 'change-button': isFromCoupon }">
            <span class="order-by-label" *ngIf="!isFromCoupon && isMybets" [i18n]="'app.orderBy'"></span>
            <span
                [ngClass]="{ 'label': !isFromCoupon, 'of-coupon': isFromCoupon }"
                [textContent]="getLabel(selectedListItem)"
                data-crlat="selected-item"></span>
            <svg [ngClass]="isFromCoupon ? 'dropdown-down-arrow-coupon coupon' : 'dropdown-down-arrow coup'">
                <use [attr.xlink:href]="'#down-arrow'"></use>
            </svg>
        </div>
    </div>

    <div class="overlay" (click)="clickHandler($event)"></div>

    <ul class="dropdown-menu" data-crlat="dropdown-menu">
        @for (item of menuList; track trackByFn(itemIndex, item); let itemIndex = $index) {
            <li class="menu-item" (click)="clickItem(item)" [ngClass]="{ active: item[nameKey] === selectedListItem }" data-crlat="dropdown.menuItem">
                <span class="menu-title" data-crlat="item-title">
                    <svg [ngClass]="'svg-icon'" *ngIf="hasSvg">
                        <use [attr.xlink:href]="'#stats-' + item[valueKeys[0]]"></use>
                    </svg>
                    {{ item[nameKey] }}
                </span>
            </li>
        }
    </ul>
</div>
